// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__v22NH","switch":"Switch_switch__khpEe","input":"Switch_input__TlHu1","slider":"Switch_slider__meYoT","disabled":"Switch_disabled__Tb8yv"};